import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment, TextField } from '@material-ui/core';

// CONSTANTS
import { MAX_APP_COST } from '@/constants/validation';

// UTILITY
import getCurrencyInfo from '@/utility/currency';

const PriceField = props => {
  const { maxPrice, currency, ...rest } = props;
  const currencyInfo = getCurrencyInfo(currency);

  return (
    <TextField
      {...rest}
      fullWidth
      type="number"
      inputProps={{ min: 0, max: maxPrice, type: 'number' }}
      InputProps={{
        startAdornment: (
          <InputAdornment className="adornment-currency" position="start">
            {currencyInfo.symbol}
          </InputAdornment>
        ),
      }}
    />
  );
};

PriceField.defaultProps = {
  currency: 'usd',
  maxPrice: MAX_APP_COST,
};

PriceField.propTypes = {
  maxPrice: PropTypes.number,
  currency: PropTypes.string,
};

export default React.memo(PriceField);
